module.exports = __webpack_public_path__ + "img/nav_gcj.3dafb7c.png";